import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.cj{background:var(--shades-white);}.ssr-plugin'
import '.cd{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b8{max-width:77.5rem;}.ssr-plugin'
import '.c5{justify-content:stretch;}.ssr-plugin'
import '.c6{position:sticky;}.ssr-plugin'
import '.c7{top:0px;}.ssr-plugin'
import '.c8{z-index:10;}.ssr-plugin'
import '.eh{padding-block:1rem;}.ssr-plugin'
import '.ei{height:3rem;}.ssr-plugin'
import '.a2{justify-content:space-between;}.ssr-plugin'
import '.cb{flex-wrap:wrap;}.ssr-plugin'
import '.ej{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b6{margin-top:2rem;}.ssr-plugin'
import '.ek{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab b e cj"
      >
        <div className="cd a f b e"
        >
          <div className="b8 a e c5 c6 c7 c8 cj"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="eh ei a a2 f cb"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ej a e ab b6 ek b8"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
